module.exports = __webpack_public_path__ + "static/media/019.e5522eba.jpg";